module.exports = __webpack_public_path__ + "static/img/service-nomember-icon.fecc417e.png";